import AddIcon from "@mui/icons-material/Add";
import clsx from "clsx";

import Icon from "@musicfy/components/Icon";

const InferenceFileUploader: React.FC<{
  isDragActive: boolean;
}> = ({ isDragActive }) => {
  return (
    <div
      className={clsx(
        "group transition-all py-6 px-12 w-full cursor-pointer rounded-12",
        {
          "bg-pink-200/15": isDragActive,
          "custom-dash bg-purple/5": !isDragActive,
        }
      )}
    >
      <div className="flex justify-between w-full items-center">
        <div className="flex flex-col w-full">
          <div className="text-white text-[26px] font-medium" aria-label="">
            Upload Audio
          </div>
          <div
            aria-label=""
            className="text-white/80 font-light capitalize lg:whitespace-nowrap"
          >
            or drag and drop mp3/wav file here.
          </div>
        </div>
        <Icon name="upload-arrow" className="w-7 h-10" />
      </div>
      <div className="h-px w-full mt-6 mb-4 bg-white/20" />
      <div className="w-12 h-12 flex items-center justify-center text-pink-200 rounded-4 border border-white/20 bg-gray-1000/20">
        <AddIcon />
      </div>
    </div>
  );
};

export default InferenceFileUploader;
